/* Lionzen · cesta (panel lateral, aviso de añadido y página de cesta)
   API global: window.LZCart.open() · close() · load() · add(variantId, qty, {toast|open}) · toast(variantId)
   Pinta en todos los contenedores [data-lzcart-lines] / [data-lzcart-progress] / [data-lzcart-foot] / [data-lzcart-upsell]. */
(function () {
  'use strict';
  if (window.LZCart) return;
  var cfgEl = document.getElementById('lzcart-config');
  if (!cfgEl) return;
  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var T = C.t;
  var state = { cart: null, busy: false };
  var drawer = document.getElementById('lzd');
  var toastEl = document.getElementById('lzt');
  var toastTimer = null;

  if (drawer) document.body.appendChild(drawer);
  if (toastEl) document.body.appendChild(toastEl);

  /* ---------- utilidades ---------- */
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function money(cents) {
    var v = (Math.round(cents) / 100).toFixed(2).split('.');
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var num = v.join(',');
    var fmt = String(C.money || '{' + '{amount_with_comma_separator}}€');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, num).replace(/<[^>]+>/g, '');
  }
  function api(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function bottleFor(title) {
    var k = (title || '').toLowerCase();
    if (k.indexOf('pack') > -1) return null;
    for (var i = 0; i < C.bottles.length; i++) { if (k.indexOf(C.bottles[i].k) > -1) return C.bottles[i]; }
    return null;
  }
  function shortTitle(t) { return String(t || '').replace(/^lionzen\s+/i, ''); }
  function isPack(t) { return /pack/i.test(t || ''); }

  /* Agrupa las líneas que Shopify separa por descuento (misma variante) */
  function groups(cart) {
    var map = {}, out = [];
    (cart.items || []).forEach(function (it) {
      var g = map[it.variant_id];
      if (!g) {
        g = map[it.variant_id] = { id: it.variant_id, keys: [], qty: 0, orig: 0, fin: 0, disc: {}, item: it };
        out.push(g);
      }
      g.keys.push(it.key);
      g.qty += it.quantity;
      g.orig += it.original_line_price;
      g.fin += it.final_line_price;
      (it.line_level_discount_allocations || []).forEach(function (a) {
        var tt = (a.discount_application && a.discount_application.title) || '';
        g.disc[tt] = (g.disc[tt] || 0) + a.amount;
      });
    });
    return out;
  }

  /* ---------- pintado ---------- */
  var progPrev = null, progNext = null, progOld = null;
  /* misma duración y curva para la barra de envío y los huecos del 3x2 */
  function animateProgress(cart) {
    if (progNext) { progOld = progPrev; progPrev = progNext; }
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      document.querySelectorAll('.lzp-bar span[data-to]').forEach(function (b) { b.style.width = b.getAttribute('data-to') + '%'; });
      document.querySelectorAll('.lzp-slots').forEach(function (box) {
        var k = 0;
        box.querySelectorAll('i').forEach(function (s) {
          var on = s.getAttribute('data-on') === '1';
          if (on !== s.classList.contains('is-on')) { s.style.transitionDelay = (k++ * 200) + 'ms'; s.classList.toggle('is-on', on); }
        });
      });
    }); });
  }
  function progressHTML(cart) {
    var total = cart.total_price;
    var freeLeft = Math.max(0, C.free - total);
    var freePct = Math.min(100, Math.round(total / C.free * 100));
    var elig = 0;
    (cart.items || []).forEach(function (it) { if (!isPack(it.product_title)) elig += it.quantity; });
    var mod = elig % 3, freebies = Math.floor(elig / 3), x3msg, filled;
    if (elig === 0) { x3msg = T.x3Two.replace('2', '3'); filled = 0; }
    if (elig > 0 && mod === 0) { x3msg = T.x3Ok.replace('%', freebies); filled = 3; }
    else if (mod === 1) { x3msg = T.x3Two; filled = 1; }
    else if (mod === 2) { x3msg = T.x3One; filled = 2; }
    /* se pinta con el estado anterior y luego se anima hasta el nuevo (ver animateProgress) */
    var prev = progPrev || { pct: freePct, filled: filled };
    progNext = { pct: freePct, filled: filled };
    var slots = '';
    for (var i = 0; i < 3; i++) slots += '<i class="' + (i < prev.filled ? 'is-on' : '') + (i === 2 ? ' is-gift' : '') + '" data-on="' + (i < filled ? 1 : 0) + '"></i>';
    return '' +
      '<div class="lzp-row' + (freeLeft === 0 ? ' is-done' : '') + '">' +
        '<div class="lzp-txt">' + (freeLeft === 0 ? '✓ ' + esc(T.freeOk) : esc(T.freeLeft).replace('%', '<b>' + esc(money(freeLeft)) + '</b>')) + '</div>' +
        '<div class="lzp-bar"><span style="width:' + prev.pct + '%" data-to="' + freePct + '"></span></div>' +
      '</div>' +
      '<div class="lzp-row lzp-row--x3' + (filled === 3 ? ' is-done' : '') + '">' +
        '<div class="lzp-slots" aria-hidden="true">' + slots + '</div>' +
        '<div class="lzp-txt">' + esc(x3msg) + '</div>' +
      '</div>';
  }

  function lineHTML(g) {
    var it = g.item, b = bottleFor(it.product_title);
    var img = b ? '<img class="lzl__bottle" src="' + esc(b.sm.replace('-sm.webp', '.webp')) + '" alt="" loading="lazy">' :
      (it.image ? '<img class="lzl__photo" src="' + esc(it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240') + '" alt="" loading="lazy">' : '');
    var discs = Object.keys(g.disc).filter(function (k) { return g.disc[k] > 0; }).map(function (k) {
      return '<span class="lzl__disc">' + esc(k || '−') + ' · −' + esc(money(g.disc[k])) + '</span>';
    }).join('');
    var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<span class="lzl__var">' + esc(it.variant_title) + '</span>' : '';
    return '<div class="lzl" data-lzl="' + g.id + '" style="--l-bg:' + esc(b ? b.bg : '#F4F4F2') + '">' +
      '<a class="lzl__media" href="' + esc(it.url) + '">' + img + '</a>' +
      '<div class="lzl__info">' +
        '<a class="lzl__name" href="' + esc(it.url) + '">' + esc(shortTitle(it.product_title)) + '</a>' +
        variant + discs +
        '<div class="lzl__row">' +
          '<div class="lzl__qty" role="group">' +
            '<button type="button" data-lzl-dec aria-label="−">−</button>' +
            '<span>' + g.qty + '</span>' +
            '<button type="button" data-lzl-inc aria-label="+">+</button>' +
          '</div>' +
          '<div class="lzl__price">' + (g.orig > g.fin ? '<s>' + esc(money(g.orig)) + '</s>' : '') + '<b>' + esc(money(g.fin)) + '</b></div>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="lzl__rm" data-lzl-rm aria-label="' + esc(T.remove) + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
    '</div>';
  }

  function emptyHTML() {
    var pics = C.bottles.slice(1, 4).map(function (b, i) { return '<img src="' + esc(b.sm.replace('-sm.webp', '.webp')) + '" alt="' + esc('Lionzen ' + ((b.img.match(/lz-bottle-([a-z]+)/) || [, b.k])[1]).replace(/^./, function (c) { return c.toUpperCase(); })) + '" style="--i:' + i + '">'; }).join('');
    return '<div class="lze"><div class="lze__pics">' + pics + '</div><p class="lze__t">' + esc(T.empty) + '</p><p class="lze__s">' + esc(T.emptySub) + '</p>' +
      '<a class="lzbtn lzbtn--dark" href="' + esc(C.shopUrl) + '">' + esc(T.shop) + '</a></div>';
  }

  function upsellHTML(cart) {
    var inCart = {};
    (cart.items || []).forEach(function (it) { inCart[it.product_id] = 1; });
    var list = (C.upsell || []).filter(function (p) { return p.a && !inCart[p.pid] && !isPack(p.t); }).slice(0, 6);
    if (!list.length || !(cart.items || []).length) return '';
    var elig = 0;
    (cart.items || []).forEach(function (it) { if (!isPack(it.product_title)) elig += it.quantity; });
    var head = (elig > 0 && elig % 3 === 0 && T.upsellNext) ? T.upsellNext : T.upsell;
    return '<div class="lzu__h">' + esc(head) + '</div><div class="lzu__track">' + list.map(function (p) {
      var b = bottleFor(p.t);
      var img = b ? '<img src="' + esc(b.sm.replace('-sm.webp', '.webp')) + '" alt="" loading="lazy">' : '<img class="is-photo" src="' + esc(p.img) + '" alt="" loading="lazy">';
      return '<div class="lzu__c" style="--l-bg:' + esc(b ? b.bg : '#F4F4F2') + '">' +
        '<a class="lzu__m" href="' + esc(p.u) + '">' + img + '</a>' +
        '<a class="lzu__n" href="' + esc(p.u) + '">' + esc(shortTitle(p.t)) + '</a>' +
        '<div class="lzu__r"><b>' + esc(money(p.p)) + '</b><button type="button" class="lzu__add" data-lzu-add="' + p.id + '" aria-label="+">+</button></div>' +
      '</div>';
    }).join('') + '</div>';
  }

  function footHTML(cart) {
    if (!(cart.items || []).length) return '';
    var save = cart.original_total_price - cart.total_price;
    return '<div class="lzf2__rows">' +
        '<div class="lzf2__r"><span>' + esc(T.subtotal) + '</span><span>' + esc(money(cart.original_total_price)) + '</span></div>' +
        (save > 0 ? '<div class="lzf2__r lzf2__r--save"><span>' + esc(T.savings) + '</span><span>−' + esc(money(save)) + '</span></div>' : '') +
        '<div class="lzf2__r lzf2__r--total"><span>' + esc(T.total) + '</span><span>' + esc(money(cart.total_price)) + '</span></div>' +
      '</div>' +
      '<p class="lzf2__tax">' + esc(T.taxes) + '</p>' +
      '<a class="lzbtn lzbtn--dark lzbtn--block" href="/checkout">' + esc(T.checkout) +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>' +
      '<a class="lzbtn lzbtn--ghost lzbtn--block lzf2__cartbtn" href="' + esc(C.cartUrl) + '" data-lzcart-page data-lzcart-viewlink>' + esc(T.view) + '</a>' +
      '<div class="lzf2__trust"><span>🔒 ' + esc(T.secure) + '</span><span>' + esc(T.made) + '</span></div>';
  }

  function renderAll() {
    var cart = state.cart; if (!cart) return;
    var gs = groups(cart);
    var empty = !gs.length;
    document.querySelectorAll('[data-lzcart-progress]').forEach(function (el) { el.innerHTML = empty ? '' : progressHTML(cart); });
    if (!empty) animateProgress(cart);
    document.querySelectorAll('[data-lzcart-lines]').forEach(function (el) { el.innerHTML = empty ? emptyHTML() : gs.map(lineHTML).join(''); });
    document.querySelectorAll('[data-lzcart-upsell]').forEach(function (el) { el.innerHTML = upsellHTML(cart); });
    document.querySelectorAll('[data-lzcart-foot]').forEach(function (el) { el.innerHTML = footHTML(cart); });
    document.querySelectorAll('[data-lzcart-empty-hide]').forEach(function (el) { el.hidden = empty; });
    var n = cart.item_count;
    document.querySelectorAll('[data-lzd-count]').forEach(function (el) { el.textContent = n ? n + ' ' + (n === 1 ? T.item : T.items) : ''; });
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
    state.groups = gs;
    try { document.dispatchEvent(new CustomEvent('lzcart:render', { detail: cart })); } catch (e) {}
  }

  function load() { return api('/cart.js').then(function (c) { state.cart = c; renderAll(); return c; }); }

  function setQty(id, n) {
    var g = (state.groups || []).filter(function (x) { return String(x.id) === String(id); })[0];
    if (!g || state.busy) return;
    state.busy = true;
    document.querySelectorAll('[data-lzl="' + id + '"]').forEach(function (el) { el.classList.add('is-busy'); });
    var u = {};
    g.keys.forEach(function (k, i) { u[k] = i === 0 ? Math.max(0, n) : 0; });
    return api('/cart/update.js', { updates: u }).then(function (c) { state.cart = c; renderAll(); })
      .catch(function () { return load(); })
      .then(function () { state.busy = false; });
  }

  function add(id, qty, opts) {
    opts = opts || {};
    return api('/cart/add.js', { items: [{ id: parseInt(id, 10), quantity: qty || 1 }] }).then(function () {
      return load();
    }).then(function (c) {
      if (opts.open) open(true);
      else if (opts.toast) toast(id);
      return c;
    });
  }


  /* ---------- botones flotantes de terceros (chat, recompensas…) ----------
     Mientras hay una capa nuestra abierta, se ocultan los elementos fijos que ocupan
     las esquinas inferiores de la pantalla, sea cual sea la app. Se restauran al cerrar. */
  var floatHidden = [];
  var OURS = ['lzd', 'lzs', 'lzt', 'lzq', 'lzh', 'lzm'];
  function topFixed(el) {
    var found = null;
    while (el && el !== document.body && el !== document.documentElement) {
      var cs = getComputedStyle(el);
      if (cs.position === 'fixed' || cs.position === 'sticky') found = el;
      el = el.parentElement;
    }
    return found;
  }
  function isOurs(el) {
    for (var i = 0; i < OURS.length; i++) { if (el.id === OURS[i] || el.closest('#' + OURS[i])) return true; }
    return false;
  }
  function hideFloating() {
    if (floatHidden.length) return;
    var w = window.innerWidth, h = window.innerHeight, pts = [];
    [24, 60, 110].forEach(function (dx) { [24, 50, 90].forEach(function (dy) { pts.push([w - dx, h - dy], [dx, h - dy]); }); });
    var seen = [];
    pts.forEach(function (pt) {
      (document.elementsFromPoint ? document.elementsFromPoint(pt[0], pt[1]) : []).forEach(function (el) {
        if (isOurs(el)) return;
        var f = topFixed(el);
        if (f && seen.indexOf(f) < 0 && !isOurs(f)) seen.push(f);
      });
    });
    seen.forEach(function (el) {
      floatHidden.push([el, el.style.visibility, el.style.opacity]);
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('opacity', '0', 'important');
    });
  }
  function showFloating() {
    floatHidden.forEach(function (r) { r[0].style.visibility = r[1]; r[0].style.opacity = r[2]; });
    floatHidden = [];
  }
  window.LZOverlay = { hide: hideFloating, show: showFloating };

  /* ---------- panel ---------- */
  function open(skipLoad) {
    if (!drawer) { window.location.href = C.cartUrl; return; }
    if (!skipLoad) load();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    hideFloating();
    document.documentElement.classList.add('lzd-lock', 'lz-ov');
    hideToast();
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lzd-lock');
    if (!document.documentElement.classList.contains('lzs-lock')) { document.documentElement.classList.remove('lz-ov'); showFloating(); }
  }

  /* ---------- aviso de añadido (añadir rápido) ---------- */
  function hideToast() { if (toastEl) { toastEl.classList.remove('is-on'); toastEl.setAttribute('aria-hidden', 'true'); } }
  function toast(variantId) {
    if (!toastEl) { open(); return; }
    var cart = state.cart || { items: [] };
    var it = (cart.items || []).filter(function (x) { return String(x.variant_id) === String(variantId); })[0];
    if (!it) { load().then(function () { toast(variantId); }); return; }
    var b = bottleFor(it.product_title);
    var img = b ? '<img src="' + esc(b.sm.replace('-sm.webp', '.webp')) + '" alt="">' : (it.image ? '<img class="is-photo" src="' + esc(it.image) + '" alt="">' : '');
    toastEl.style.setProperty('--l-bg', b ? b.bg : '#F4F4F2');
    var keep = progPrev; if (progOld) progPrev = progOld;
    toastEl.innerHTML = '<div class="lzt__m">' + img + '</div>' +
      '<div class="lzt__b"><span class="lzt__k">✓ ' + esc(T.added) + '</span><strong>' + esc(shortTitle(it.product_title)) + '</strong>' +
      '<div class="lzt__p">' + progressHTML(cart) + '</div></div>' +
      '<div class="lzt__a"><button type="button" class="lzbtn lzbtn--dark lzbtn--sm" data-lzt-open>' + esc(T.view) + ' · ' + cart.item_count + '</button>' +
      '<button type="button" class="lzt__x" data-lzt-x aria-label="' + esc(T.close) + '">×</button></div>';
    progPrev = keep; animateProgress(cart);
    toastEl.classList.add('is-on');
    toastEl.setAttribute('aria-hidden', 'false');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 5200);
  }
  if (toastEl) {
    toastEl.addEventListener('mouseenter', function () { clearTimeout(toastTimer); });
    toastEl.addEventListener('mouseleave', function () { toastTimer = setTimeout(hideToast, 2500); });
  }

  /* ---------- eventos ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-lzcart-open]');
    if (opener) { e.preventDefault(); open(); return; }
    var full = t.closest('[data-lzcart-page]');
    if (full) { e.preventDefault(); e.stopPropagation(); window.location.href = full.getAttribute('href') || C.cartUrl; return; }
    if (t.closest('[data-lzd-close]')) { close(); return; }
    if (t.closest('[data-lzt-open]')) { open(); return; }
    if (t.closest('[data-lzt-x]')) { hideToast(); return; }
    var line = t.closest('[data-lzl]');
    if (line) {
      var id = line.getAttribute('data-lzl');
      var g = (state.groups || []).filter(function (x) { return String(x.id) === String(id); })[0];
      if (!g) return;
      if (t.closest('[data-lzl-inc]')) setQty(id, g.qty + 1);
      else if (t.closest('[data-lzl-dec]')) setQty(id, g.qty - 1);
      else if (t.closest('[data-lzl-rm]')) setQty(id, 0);
      return;
    }
    var up = t.closest('[data-lzu-add]');
    if (up) {
      up.classList.add('is-busy');
      api('/cart/add.js', { items: [{ id: parseInt(up.getAttribute('data-lzu-add'), 10), quantity: 1 }] }).then(load)
        .catch(function () {}).then(function () { up.classList.remove('is-busy'); });
    }
  });
  /* clic fuera del panel: cerrar la cesta */
  var wasOpen = false;
  document.addEventListener('pointerdown', function (e) { wasOpen = !!(drawer && drawer.classList.contains('is-open') && !e.target.closest('.lzd__panel')); }, true);
  document.addEventListener('click', function (e) {
    if (!wasOpen || !drawer || !drawer.classList.contains('is-open')) return;
    if (e.target.closest('.lzd__panel') || e.target.closest('#lzt')) return;
    wasOpen = false; e.preventDefault(); e.stopPropagation(); close();
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); hideToast(); } });

  /* El side-cart de Ella sigue intentando abrirse tras añadir desde la ficha:
     lo interceptamos y abrimos el nuestro. */
  var obs = new MutationObserver(function () {
    if (document.body.classList.contains('cart-sidebar-show')) {
      document.body.classList.remove('cart-sidebar-show');
      open();
    }
  });
  obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  window.LZCart = { open: open, close: close, load: load, add: add, toast: toast, render: renderAll, state: state };

  /* Página de cesta: pinta al instante con los datos servidos por Liquid */
  var initial = document.getElementById('lzcart-initial');
  if (initial) {
    try { state.cart = JSON.parse(initial.textContent); renderAll(); } catch (e) {}
  }
  load().catch(function () {});
})();
